<div class="PGProductCard" #productCardElement>
    <div class="card">
        @if (isLoading) {
            <div class="PGProductCard-Loading">
                <app-pg-loading></app-pg-loading>
            </div>
        }
        @if (!isLoading) {
            @if (productCardData; as product) {
                @if (product.cover) {
                    <div class="card-img-top bg-secondary" [style.backgroundImage]="'url(&quot;' + product.cover + '&quot;)'"></div>
                }
                <div class="card-body">
                    @if (product.type != null) {
                        <div class="PGProductCard-Type mb-2 text-end">
                            <span class="badge text-white bg-{{getProductTypeClass()}}">
                                <i class="fa-regular {{getProductTypeIcon()}}"></i>
                                <span class="ms-2">{{ 'pg-product-card.type-' + product.type | locTranslate }}</span>
                            </span>
                        </div>
                    }
                    @if (!compact) {
                        <div class="float-end PGProductCard-Print py-1">
                            <button class="btn btn-sm btn-primary py-0 px-1 d-block" (click)="downloadPDF()">
                                <span>PDF</span>
                            </button>
                        </div>
                    }
                    <span pdfgen="block">
                        <h4 class="card-title mb-3">
                            <span pdfgen="line" pdfgen-weight="bold" pdfgen-h="1">{{product.name}}</span>
                        </h4>
                        @if (hasProperty(product.abstract)) {
                            <h6 class="card-subtitle mb-3 text-muted" [innerHTML]="product.abstract" pdfgen="line"></h6>
                        }
                        @if (hasProperty(product.description)) {
                            <div #cardDescription class="card-text mb-3 {{ compact && isDescriptionCollapsed ? 'PGProductCard-Description--Short' : ''}}" [innerHTML]="product.description" pdfgen="line"></div>
                            @if (hasDescriptionCollapse) {
                                <div class="PGProductCard-Description-Collapse text-end mb-3">
                                    <div>
                                        <button class="btn btn-link p-0 btn-sm" (click)="isDescriptionCollapsed = !isDescriptionCollapsed">
                                            {{ 'pg-product-card.description-' + (isDescriptionCollapsed ? 'more' : 'less') | locTranslate }}
                                        </button>
                                    </div>
                                </div>
                            }
                        }
                        @if (hasProperty(product.location)) {
                            <div class="PGProductCard-Property mb-2">
                                <div pdfgen="line" pdfgen-weight="bold">
                                    <i class="fa-regular fa-map-marker text-muted me-1"></i>{{ 'pg-product-card.label-place' | locTranslate }}
                                </div>
                                <div pdfgen="line">
                                    @if (product.geolocation != null) {
                                        <a target="_blank" href="{{getProductGeolocationURL()}}">
                                            {{product.location}}
                                        </a>
                                    }
                                    @if (product.geolocation == null) {
                                        {{product.location}}
                                    }
                                </div>
                            </div>
                        }
                        @if (!compact && product.price_on_request) {
                            <div class="PGProductCard-Property mb-2">
                                <div pdfgen="line" pdfgen-weight="bold">
                                    <i class="fa-regular fa-tag text-muted me-1"></i>{{ 'pg-product-card.label-price' | locTranslate }}
                                </div>
                                <div pdfgen="line">
                                    <span>{{ 'pg-product-card.price-on-request' | locTranslate }}</span>
                                </div>
                            </div>
                        }
                        @if (!product.price_on_request) {
                            @if (!compact && hasProperty(product.price)) {
                                <div class="PGProductCard-Property mb-2">
                                    <div pdfgen="line" pdfgen-weight="bold">
                                        <i class="fa-regular fa-tag text-muted me-1"></i>{{ 'pg-product-card.label-price' | locTranslate }}
                                    </div>
                                    <div pdfgen="line">
                                        <span [ngClass]="{ 'text-success': discountVal != null && discountVal != 0 }">{{formatPrice(product.price, true)}}</span>
                                        @if (discountVal != null && discountVal != 0) {
                                            <span class="PGProductCard-FullPrice">{{formatPrice(product.price)}}</span>
                                        }
                                    </div>
                                </div>
                            }
                            @if (!compact && hasProperty(product.tickets)) {
                                <div class="PGProductCard-Property mb-2">
                                    <div pdfgen="line" pdfgen-weight="bold">
                                        <i class="fa-regular fa-tag text-muted me-1"></i>{{ 'pg-product-card.label-tickets' | locTranslate }}
                                    </div>
                                    <div pdfgen="line">
                                        <span [ngClass]="{ 'text-success': discountVal != null && discountVal != 0 }" [innerHTML]="formatTickets(product.tickets, true)"></span>
                                        @if (discountVal != null && discountVal != 0) {
                                            <span class="PGProductCard-FullPrice" [innerHTML]="formatTickets(product.tickets)"></span>
                                        }
                                    </div>
                                </div>
                            }
                            @if (!compact && hasProperty(product.payment)) {
                                <div class="PGProductCard-Property border-top mb-2 pt-2">
                                    <div pdfgen="line" pdfgen-weight="bold">
                                        {{ 'pg-product-card.label-payment' | locTranslate }}
                                    </div>
                                    <div pdfgen="line">
                                        {{formatPayment(product.payment)}}
                                    </div>
                                </div>
                            }
                        }
                    </span>
                    @if (productCardSupplierData; as supplier) {
                        <div class="PGProductCard-Supplier {{isSupplierProduct() ? 'PGProductCard-Supplier--IsSupplierProduct' : ''}} border-top my-3 pt-3" pdfgen="block">
                            <div class="row">
                                <div class="{{ supplier.logo != null && supplier.logo != '' ? 'col-8' : 'col-12'}}">
                                    <h5 class="mb-3" pdfgen="line" pdfgen-h="2">{{supplier.name}}</h5>
                                    @if (!compact && supplier.description != null) {
                                        <div class="PGProductCard-Supplier-Description mb-3" [innerHTML]="supplier.description" pdfgen="line"></div>
                                    }
                                    @if (supplier.phone != null) {
                                        <div class="PGProductCard-Supplier-Contact" pdfgen="line">
                                            <span class="PGProductCard-Supplier-Contact-Label">
                                                <i class="fa-regular fa-phone text-muted me-1"></i>
                                                <span>{{ 'pg-product-card.label-phone' | locTranslate }}</span>
                                            </span>
                                            <a href="tel:{{supplier.phone}}">{{supplier.phone}}</a>
                                        </div>
                                    }
                                    @if (supplier.email != null) {
                                        <div class="PGProductCard-Supplier-Contact" pdfgen="line">
                                            <span class="PGProductCard-Supplier-Contact-Label">
                                                <i class="fa-regular fa-envelope text-muted me-1"></i>
                                                <span>{{ 'pg-product-card.label-email' | locTranslate }}</span>
                                            </span>
                                            <a href="mailto:{{supplier.email}}">{{supplier.email}}</a>
                                        </div>
                                    }
                                    @if (supplier.website != null) {
                                        <div class="PGProductCard-Supplier-Contact" pdfgen="line">
                                            <span class="PGProductCard-Supplier-Contact-Label">
                                                <i class="fa-regular fa-globe text-muted me-1"></i>
                                                <span>{{ 'pg-product-card.label-website' | locTranslate }}</span>
                                            </span>
                                            <a target="_blank" href="{{supplier.website}}">{{supplier.website}}</a>
                                        </div>
                                    }
                                    @if (supplier.store_url != null) {
                                        <div class="PGProductCard-Supplier-Contact" pdfgen="line">
                                            <span class="PGProductCard-Supplier-Contact-Label">
                                                <i class="fa-regular fa-shopping-cart text-muted me-1"></i>
                                                <span>{{ 'pg-product-card.label-store_url' | locTranslate }}</span>
                                            </span>
                                            <a target="_blank" href="{{supplier.store_url}}">{{supplier.store_url}}</a>
                                        </div>
                                    }
                                </div>
                                @if (supplier.logo != null && supplier.logo != '') {
                                    <div class="col-4">
                                        <img  class="PGProductCard-Supplier-Image" [src]="supplier.logo"/>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div #cardFooter [hidden]="!hasContent" class="card-footer text-end">
                    <ng-content></ng-content>
                </div>
            }
        }
    </div>
</div>
